module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_wright_sm-76092fb68918b9aa7f5ff0fdc562bc16.png";